/**
 * Remove o prefixo do código do campo (ex: "C088-") do início de uma string.
 *
 * O formato TISS/ANS prefixa cada entrada de motivo/campo com uma letra
 * seguida de 3 dígitos e um hífen (ex: "C088-1202-NÚMERO DO CNES INVÁLIDO").
 * Esta função remove esse prefixo, mantendo apenas a parte relevante
 * (ex: "1202-NÚMERO DO CNES INVÁLIDO").
 */
export function stripGuiaFieldPrefix(value: string): string {
  return value.replace(/^[A-Z]\d{3}-/i, '');
}

/**
 * Aplica stripGuiaFieldPrefix em cada linha de uma string multilinha,
 * tratando valores null/undefined de forma segura.
 */
export function normalizeGuiaMotivo(value: string | null | undefined): string {
  if (!value) return '';
  return value
    .split('\n')
    .map(line => stripGuiaFieldPrefix(line.trim()))
    .filter(Boolean)
    .join('\n');
}
